import { makeStyles } from "@material-ui/core";


export const useLiveUnitNavStyles = makeStyles(theme => ({
    root: {
        backgroundColor: "white",
        borderBottom: `1px solid ${theme.palette.grey[300]}`,
    },
    inner: {
        margin: "0 5.2em",
        width: "auto",
    },
    hidden: {
        display: "none",
    },
    searchBarWrapper: {
        width: "100%",
        height: "50px",
        display: "flex",
    },
    navWrapper: {
        display: "grid",
        gridTemplateColumns: "4.5fr min-content 3fr",
        height: 90,
        position: "relative",
    },
    titleWrapper: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        padding: "1em 0",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
    placeholderSearchBox: {
        minWidth: "27em",
        padding: "1em 0",
        ["@media (max-width: 1440px)"]: {
            minWidth: "10.5em",
            width: "10.5em",
        },
        ["@media (max-width: 1280px)"]: {
            minWidth: "5.5em",
            width: "5.5em",
        },
    },
    back: {
        color: theme.palette.grey[700],
    },
}));
